import { filter, takeUntil } from "rxjs/operators";
import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  NgZone 
} from "@angular/core";
import { AjaxService } from ".././services/ajax.service";
import { UserDetailsService } from ".././services/user-details.service";
import { Utility } from "../shared/utility/utility";
import {
  Router,
  ActivatedRoute,
  NavigationError,
  NavigationEnd
} from "@angular/router";
import { EmitterService } from "../services/emitter.service";
import { RealityCheckService } from "../services/reality-check.service";
import { GameWindowService } from "../services/gameWindow.services";
import { environment } from "../../environments/environment";
import { SocketService } from "../services/socket.service";
import { CountryDataService } from "../services/country.service";
import * as $ from "jquery";
window["$"] = window["jQuery"] = $;
import * as _ from "underscore";
import { BannerService } from "../services/banner.service";
import { LogoutEmitServiceService } from "../services/logout-emit-service.service";
import { AppDetailsService } from "../services/app-details.services";
import { TranslateService } from "@ngx-translate/core";
import { ZendeskService } from "../services/zendesk.servcie";
import { Subject, Subscription } from "rxjs";
import { PnpZimplerService } from "../services/pnp-zimpler.service";
import { PromotionsService } from '../services/promotions.service';
import { PoliciesVersionService } from "../services/policies-version.service";
import { language, policiesTypes, userJurisdictions } from "../shared/utility/config";
import { PnpUserService } from "../pnp-user.service";
import { PaymentService } from "../services/payment.service";
import { Utilities } from '../services/utilities.services';

@Component({
  selector: "app-header",
  templateUrl: "./app-header.component.html",
  styleUrls: ["./app-header.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AppHeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  windowType;
  details;
  isUserLoggedIn;
  userNickName: string = "";
  userFullName: String = "";
  userCurrencySymbol;
  userCashBalance;
  userTotalBalance;
  userBonusBalance;
  cash: number = -1;
  currency: string;
  profileData;
  completeUser;
  balanceView: boolean = false;
  showRegNavBar: boolean = false;
  isProfileCompleted;
  activeTab;
  sortedGameData;
  selectedGames;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  searchGame;
  userLogin;
  searchInput;
  email;
  userDetail;
  currentURL_slug: any;
  currentURL = "";
  langCode: any = "en";
  accountStatus;
  accountPreference;
  setLimitUrl;
  isGamePage: boolean = false;
  scrollCurrentVal: number;
  scrollPreviousVal: number = 0;
  activeScrolled: boolean;
  countryList;
  isCountryAllowed: number = 0;
  isSwedenJurisdictionShowNotification = false;
  paymentInitialise = false;
  pnpDepositInitialise: boolean = false;
  isPnPUser = false;
  queryparamObject = {};
  openDepositModal = false;
  pageurlid;
  routerEvent;
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;
  totalSearchedGames;
  searchResultsDefaultSize = 6;
  loadMoreSearchGames = this.searchResultsDefaultSize;
  @Output() loaderStatus = new EventEmitter<{}>();
  openQuickLoginModal = false;
  selectedGamesOverlay = false;
  title;
  cashierType: String = "deposit";
  gameplayWindowMinimized: boolean = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  dynamicHrefPath;
  isShowDepositPending;
  isShowEstoniaNotice = false;
  showPendingWithdrawl: boolean = false;

  isZimplerProfile: boolean = false;
  isZimplerProfileSub: Subscription;
  isCountryAllowedSub: Subscription;
  isGameModal = false;
  specialPromotions;
  isZendeskEnabled = environment.zendeskServiceConfig["isEnabled"];
  isTudiChatEnabled = environment.tugiChatConfig.tugiChatEnabled;
  registrationStep = 'step1'
  clonedPoliciesTypes: unknown[];

  isSideMenuOpened = false;
  isShowCashier = false;
  isShowTransactionNotification = false;
  transactionNotification;
  blockedUserSegments = environment.blockedUserSegments;
  isTugiChatBotOpen = false;

  @HostListener("window:resize") onResize() {
    this.checkResizedOrientation();
    this.leftNavReg();
    this.zimplerToggleResize();
  }
  @HostListener("window:orientationchange") onOrientationChange() {
    this.checkResizedOrientation();
  }
  @HostListener("window:scroll", ["$event"]) onScroll(event) {
    if (this.windowType === "mobile") {
      this.checkScrollUporDown();
    } else {
      this.changeHeaderTheme();
    }
  }
  @HostListener("document:click", ["$event"]) onClick(event) {
    // if (event.target.classList.contains("overlay")) {
    //   this.emitterService.broadCastToggleNavPanel(false);
    //   //this.emitterService.broadCastIsZimplerForm(false)
    //   document.body.classList.remove('hiddenOverflow');
    // }
    if (event.target.classList.contains("search_game_field")) {
      this.emitterService.broadCastToggleNavPanel(false);
      this.emitterService.broadCastIsZimplerForm(false)

    }
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if(this.utils.isUserLoggedIn() && this.userDetail?.jurisdiction && userJurisdictions.includes(this.userDetail.jurisdiction)
    ){
      this.policiesVersionService.checkPolociesInfo();
    }
  }
  constructor(
    public userDetailsService: UserDetailsService,
    private ajaxService: AjaxService,
    private utils: Utility,
    private router: Router,
    private emitterService: EmitterService,
    private realityCheckService: RealityCheckService,
    private gameservice: GameWindowService,
    private socketService: SocketService,
    private activatedRoute: ActivatedRoute,
    private bannerService: BannerService,
    private logoutForceService: LogoutEmitServiceService,
    private countryDataService: CountryDataService,
    private appDetails: AppDetailsService,
    private translate: TranslateService,
    private zendesk: ZendeskService,
    private pnpService: PnpZimplerService,
    private promotionsService: PromotionsService,
    private policiesVersionService:PoliciesVersionService,
    private pnpUserService:PnpUserService,
    private pmService:PaymentService,
    private utilities: Utilities,
    private ngZone: NgZone
  ) {

    this.emitterService.showPreferenceFromNotificationBanner$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.openNavPanel();
    });

    this.emitterService.sideMenuStatus$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isSideMenuOpened = status
    });

    this.userDetail = this.userDetailsService.getUserProfileDetails();

    this.langCode = localStorage.getItem("langCode");
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
      this.utils.getTime();
    });

    this.emitterService.getLangBasedResponse$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.getAllPromotionData(true);
    });
    this.emitterService.showDepositNotification$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isShowDepositPending = status
    });
    this.emitterService.checkXSaleRegistration$.pipe(takeUntil(this.destroy$)).subscribe(status => {
        this.checkXSaleCondition();
    });

    this.emitterService.routeChangeState$.pipe(takeUntil(this.destroy$)).subscribe(state => {
      this.showRegNavBar = !window.location.href.includes('register') && !state ? false : state;
      if (state) {
        this.registrationStep = 'step2'
        this.emitterService.broadCastLeftSideCompleteProfileShow(true);
      } else {
        this.registrationStep = 'step1'
      }
    });
    this.emitterService.triggerInitializePayement$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      this.initialisePayment();
    });
    this.emitterService.userDataSource$.pipe(takeUntil(this.destroy$)).subscribe(userDataSource => {
      if (userDataSource === "User Data Updated") {
        const userData = this.userDetailsService.getUserProfileDetails();
        this.userNickName = userData["nickname"];
        this.userFullName = userData["firstName"];
        this.email = userData["email"];
        this.userDetail = userData;
      }
    });
    this.clonedPoliciesTypes = Object.values(policiesTypes);
    this.emitterService.isZimplerForm$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isZimplerProfile = data;
      if (!data) {
        this.closeSearch();
        this.closeAllModals()
      }
      this.zimplerToggleResize()
    })

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.isCountryAllowed = data;
    })

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeTabName();
      }
    });

    this.emitterService.logoutComplete$.pipe(takeUntil(this.destroy$)).subscribe(logoutStatus => {
      this.doLogout(logoutStatus);
    });

    this.emitterService.setLimitsSource$.pipe(takeUntil(this.destroy$)).subscribe(setLimit => {
      this.setLimitUrl = setLimit;
    });

    this.emitterService.accountStatusSource$.pipe(takeUntil(this.destroy$)).subscribe(accountStatus => {
      this.accountStatus = accountStatus;
    });

    this.emitterService.accountPreferenceSource$.pipe(takeUntil(this.destroy$)).subscribe(accountPreference => {
      this.accountPreference = accountPreference;
    });

    this.logoutForceService.forceLogout$.pipe(takeUntil(this.destroy$)).subscribe(setLimit => {
      this.emitterService.broadcastLoginStatus(false);
    });

    this.emitterService.isGameWindowMinimized$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.gameplayWindowMinimized = status;
    });

    this.emitterService.actionNotPermitter$.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event === "NO_REG_FROM_COUNTRY") {
        this.utils.openModal("restrict_reg_modal");
      }
    });

    this.emitterService.txnComplete$.pipe(takeUntil(this.destroy$)).subscribe(txnStatus => {
        this.getUserDetails("");
    });

    this.userDetailsService.userTotalBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(userTotalbalance => {
      this.userTotalBalance = userTotalbalance;
    });

    this.userDetailsService.userBonusBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(userBonusBalance => {
      this.userBonusBalance = userBonusBalance;
    });

    this.emitterService.loginComplete$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
      this.getUserDetails(loginStatus);
    });

    this.emitterService.depositeSuccess$.pipe(takeUntil(this.destroy$)).subscribe(staus => {
      this.getUserDetails('');
    });

    this.emitterService.headerTopicSource$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.activeTab = "";
      if (status === "video_slots") {
        this.activeTab = "video_slots";
      } else if (status === "live_casino") {
        this.activeTab = "live_casino";
      } else if (status === "promotions") {
        this.activeTab = "promotions";
      } else if (status === "home") {
        this.activeTab = "home";
      }
    });

    this.emitterService.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.userLogin = this.utils.isUserLoggedIn();
    });
    this.emitterService.openLeftNavPanelForFinland$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.openRegNavbar();
    });

    this.emitterService.openMergeModal$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.openModal("mergeConfirmation");
    });
    
    this.emitterService.cashierModalState$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.isShowCashier = status;
    });

    this.emitterService.showRegModal$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      if (!this.userDetailsService.checkIsPNPUser()) {
      setTimeout(() => {
        this.checkIsRegistrationPage();
        });
      }
    });

    this.emitterService.isGameModal$.subscribe(bool => {
      if (bool === true) {
        this.utils.openModal('slotGameModal');
      } else {
        this.utils.closeModal('slotGameModal');
      }
    })

    /*This subscriber handles the need for change of class variables.
      Ex. deposit_modal needs to be closed. After closing the Modal, the corresponding
      component needs to be closed
    */
    this.emitterService.modalState$.pipe(takeUntil(this.destroy$)).subscribe((props: any) => {
      const name = props.name;
      const state = props.state;
      if(!this.utils.isUserLoggedIn()){
        localStorage.removeItem('sessionTimerInfo');
      }
     if(state == 'close'){
      this.utils.closeModal("pendingwithdrawal");
      this.utils.closeModal("custom_cashier_modal");
      this.utils.closeModal("pnpDepositModal");
      this.toggelNormalDepositModal('close','')
      this.pnpDepositInitialise = false;
      this.showPendingWithdrawl = false;
      return
     }
     
      if (name === "pnpDepositModal") {
        this.switchPaymentMethod(state, props, "pnpDepositModal");
        return;
      }
      Promise.resolve(this.userDetailsService.checkUserProfile(true)).then(
        (profileData) => {
          if (!profileData) {
            const serverError = this.translate.instant("errors.error1"); //"Server is facing some error.";
            this.emitterService.broadcastserverError(
              serverError,
              this.router.url
            );
            return;
          }
          if ((profileData && !profileData["userProfileCompleted"]) && !this.userDetailsService.isRealUserAccount() && !this.userDetailsService.checkIsPNPUser()) {
            this.emitterService.broadCastToggleNavPanel(false);
            localStorage.removeItem('showRegisterPage');
            localStorage.setItem('isFromDeposit','true');
            this.utils.goToCompleteProfile();
            return;
          }

          switch (name) {
            case "paymentModal":
              this.switchPaymentMethod(state, props);
              break;

            case "pendingwithdrawl":
              if (state === "close") {
                this.showPendingWithdrawl = false;
                this.utils.closeModal("pendingwithdrawal");
              } else if (state === "open") {
                this.showPendingWithdrawl = true;
              }

              break;
          }
        }
      );
    });
  }
  switchPaymentMethod(state,props, pnpModal=null)  {
    if(props.cashierType != "withdrawal" && this.blockedUserSegments?.length && this.utils.isUserLoggedIn()){
     this.ajaxService.getUserSegments().subscribe(
      (segmentsResponse) => {
        if (segmentsResponse?.segmentList?.length && this.blockedUserSegments.some(segment => segmentsResponse?.segmentList.includes(segment))) {
           this.utils.openModal('blockedUserModal');
        } else {
          this.callTransactionModals(props,pnpModal,state)
        }
      },
      (error) => {
        this.callTransactionModals(props,pnpModal,state)
      }
    );
    }else{
      this.callTransactionModals(props,pnpModal,state)
    }
  
     
  }
  callTransactionModals(props,pnpModal,state){
    if(props.cashierType != "withdrawal"){
      if(!this.utils.cashierConfigInfo && this.utils.isUserLoggedIn()){
        this.pmService.getPaymentMethod().then((cashierInfo:any) =>{
          if(cashierInfo.status == 'SUCCESS'){
            this.checkCashierConfig(cashierInfo,pnpModal,state,props)
           this.utils.cashierConfigInfo = cashierInfo;
          }
        })
      }else{
        this.checkCashierConfig(this.utils.cashierConfigInfo,pnpModal,state,props)
      }
     
    }else{
      this.triggerTransactionModals(pnpModal, state, props)
    }
  }
  checkCashierConfig(cashierInfo,pnpModal,state,props){
    if(cashierInfo && cashierInfo.cashierType == 'internal'){
      this.isShowCashier = true;
        setTimeout(()=>{
          this.emitterService.broadCastCashierModalState(true);
          this.utils.openModal("custom_cashier_modal");
        })
    }else{
      this.triggerTransactionModals(pnpModal, state, props)
    }
  }
  triggerTransactionModals(pnpModal, state, props){
    if(pnpModal){
      this.togglePnpModal(state,props);
    }else{
      this.toggelNormalDepositModal(state,props);
    }
  }

  toggelNormalDepositModal(state,props){
    if (state === "close") {
      this.paymentInitialise = false;
      this.queryparamObject = {};
      this.openDepositModal = false;
      this.cashierType = "deposit";
      this.utils.closeModal("hosted_cashier_modal");

    } else if (state === "open") {
      this.paymentInitialise = true;
      this.cashierType = props.cashierType;
    }
  }
  togglePnpModal(state,props){
    if (state === "close") {
      this.pnpDepositInitialise = false;
      this.utils.closeModal("pnpDepositModal");
    } else if (state === "open") {
      this.pnpDepositInitialise = true;
      this.utils.openModal('pnpDepositModal');
    }
  }
  closeAllModals() {
    this.balanceView = false;
    this.showRegNavBar = false;
  }

  moveToTrustlyPay(){
    if((this.userDetail && (environment.semiPnpZimplerCountries.indexOf(this.userDetail['country'])>=0 || environment.zimplerCountries.indexOf(this.userDetail['country'])>=0)) || !this.isUserLoggedIn && this.isCountryAllowed===1)
      this.pnpService.openZimplerDeposit();
    else {
      this.initialisePayment();
    }
       
    }

  moveToTrustlyLogin() {
    this.pnpService.openZimplerLogin()
  }

  closeRegNavBar() {
    this.emitterService.broadcastRouteChange(false);
  }

  zimplerToggleResize() {

    setTimeout(() => {
      if (this.isZimplerProfile) {
        $(".zimpler_profile--toggle.show-profile").css({ left: $(".header_logo--section").width() + "px", });
      } else {
        $(".zimpler_profile--toggle.hide-profile").css({ left: "-100% !important" });
      }
    });
  }

  activeTabName() {
    this.activeTab = this.langCode
      ? window.location.pathname.slice(3)
      : window.location.pathname;
  }

  onTugiWidgetOpened = () => {
    this.ngZone.run(() => {
      this.isTugiChatBotOpen = true;
    });
  }
  
  onTugiWidgetClosed = () => {
    this.ngZone.run(() => {
      this.isTugiChatBotOpen = false;
    });
  }

  ngOnInit() {
    this.utils.getTime();
    this.activatedRoute.queryParamMap.pipe(takeUntil(this.destroy$)).subscribe(queryParams => {
      let path = window.location.pathname.substring(3);
      // read cxd, c, affname only when affid is given in the url
      if (queryParams.get("affid")) {
        this.utils.setAffliateInCookie("affiliate", queryParams.get("affid"));
        this.utils.setAffliateInCookie("affiliatename", "incomeaccess");
        if (queryParams.get("affname")) {
          this.utils.setAffliateInCookie(
            "affiliatename",
            queryParams.get("affname")
          );
        }
        if (queryParams.get("CXD") || queryParams.get("cxd")) {
          let cxd = queryParams.get("CXD") || queryParams.get("cxd");
          if (cxd.search("c_") !== -1) {
            this.utils.setAffliateInCookie("cvalue", cxd.split("c_")[1]);
          }
          this.utils.setAffliateInCookie("tracker", cxd);
        }
        if (queryParams.get("c") || queryParams.get("C")) {
          this.utils.setAffliateInCookie(
            "cvalue",
            queryParams.get("c") || queryParams.get("C")
          );
        }
      }
      // if (queryParams.get('cxd')) {
      //   this.utils.setAffliateInCookie('tracker', queryParams.get('cxd'));
      // }
      let service = queryParams.get("service");
      if (service === "deposit") {
        this.queryparamObject["amount"] = queryParams.get("amount");
        this.queryparamObject["bonuscode"] = queryParams.get("bonus");
        this.queryparamObject["step"] = queryParams.get("step");
        this.openDepositModal = true;
        this.redirectToLoginWhenNotLoggedin();
      }
      if (queryParams.get("step") && service !== "deposit") {
        this.queryparamObject["step"] = queryParams.get("step");
        this.queryparamObject["method"] = queryParams.get("method");
        this.openDepositModal = true;
        this.redirectToLoginWhenNotLoggedin();
      }
      if (queryParams.get("pageurlid")) {
        this.pageurlid = queryParams
          .get("pageurlid")
          .replace(new RegExp("%2F", "g"), "/");
        if (service === "deposit" || this.router.url.includes("login")) {
          localStorage.setItem("redirectStep", this.pageurlid);
        } else {
          this.router.navigate([this.langCode + "/" + this.pageurlid]);
          this.redirectiondecider(this.pageurlid);
        }
      }

      if (
        queryParams.get("showDeposit") ||
        queryParams.get("showWithdraw") ||
        queryParams.get("pendingCashout") ||
        queryParams.get("showDepositLogin")
      ) {

        let options: any = { state: "open" };

        //Deposit and Withdrawl Modal Conditions goes here
        if (
          queryParams.get("showDeposit") ||
          queryParams.get("showWithdraw")
        ) {
          if (this.userDetailsService.checkIsPNPUser()) {
            if ((this.userDetailsService.checkZimplerDepositOpen())) {
              queryParams.get("showDeposit") ? this.pnpService.openZimplerDeposit() : this.pnpService.openZimplerWithDraw()
            }
            this.resetUrlWithoutParams(path);
            return;
          } else {
            if ((environment.zimplerCountries.indexOf(this.countryDataService.ipCountry) >= 0 ||  environment.semiPnpZimplerCountries.indexOf(this.countryDataService.ipCountry) >= 0) && queryParams.get("showDeposit")) {
              this.moveToTrustlyPay();
              this.resetUrlWithoutParams(path);
              return;
            } else {
              options.name = "paymentModal";
              queryParams.get("showDeposit") ? options.cashierType = 'deposit' : options.cashierType = 'withdrawal';
            }
          }

        }

        // showDepositLogin Modal
        if ((environment.zimplerCountries.indexOf(this.countryDataService.ipCountry) >= 0 || environment.semiPnpZimplerCountries.indexOf(this.countryDataService.ipCountry) >= 0) && queryParams.get("showDepositLogin")) {
          this.moveToTrustlyLogin();
          this.resetUrlWithoutParams(path);
          return;
        }

        // Pending Withdraw Modal
        if (queryParams.get("pendingCashout")) {
          options.name = "pendingwithdrawl";
        }


        this.setModalState(options);
        this.resetUrlWithoutParams(path);
      }
      //Old flow commented
      // if (queryParams.get("signup")) {
      //   setTimeout(() => {
      //     if (this.windowType === 'desktop') {
      //       this.showRegNavBar = true;
      //       this.leftNavReg();
      //       this.zimplerToggleResize();
      //     }
      //     this.resetUrlWithoutParams(path);
      //   });
      // }

    });
    if (this.router.url === "/ ") {
      this.emitterService.broadcastHeaderTopicSource("home");
    }
    this.searchGame = "";
    this.userLogin = this.utils.isUserLoggedIn();
    if (
      !this.gameservice.getAllSlotData() ||
      this.gameservice.getAllSlotData() === "" ||
      this.gameservice.getAllSlotData().length === 0
    ) {
      Promise.resolve(this.gameservice.getAllCasinoGames()).then(
        (sortedGameData) => {
          this.sortedGameData = sortedGameData;
        }
      );
    } else {
      this.sortedGameData = this.gameservice.getAllSlotData();
    }
    Promise.resolve(this.ajaxService.getLoginStatus()).then(
      (data) => {
        if (data && data["status"] === true) {
          this.socketService.connectToScoket(
            data["pragmaticUrl"],
            data["pragmaticSessionId"]
          );
          this.getUserDetails("");
          // sessionStorage.setItem("user", "true");
          this.realityCheckService.getSessionDetails("");
        } else {
          this.isUserLoggedIn = false;
          this.userDetail = null;
          this.userDetailsService.removeUserData();
          //sessionStorage.removeItem("user");
          //sessionStorage.removeItem("session");
          //localStorage.removeItem("userLangCode");
          this.emitterService.broadcastStatusCall("updated");
          //this.emitterService.broadcastlogoutComplete("userLoggedOff");
          /*If user is not logged in and deposit modal needs to be open , first login*/
          if (this.openDepositModal) {
            this.router.navigate([this.langCode + "/login"]);
          }
        }
      },
      (SystemError) => {
        this.isUserLoggedIn = false;
        this.userDetail = null;
      }
    );

    this.leftNavReg();
    this.zimplerToggleResize();

    // This even will listen for removal of localstorage item in new Tabs
    // And logout user from all tabs
    window.addEventListener('storage', (e) => {
      if (e.type === 'storage' && e.key === 'loginstatus' && e.newValue === null) {
        this.doLogout("");
      }

      // This will trigger login in all other Tabs
      if (e.type === 'storage' && e.key === 'loginstatus' && e.newValue === 'true') {
        this.router.navigate([this.langCode]);
        this.emitterService.broadcastloginComplete("loginsuccess");
        this.bannerService.clearBanners();
      }
    });

    this.utils.setDynamicUrlHref();
    this.dynamicHrefPath = this.utils.getDynamicUrlHref();

    document.addEventListener('tugi-widget-opened', this.onTugiWidgetOpened);
    document.addEventListener('tugi-widget-closed', this.onTugiWidgetClosed);
  }

  checkIsRegistrationPage() {
    let ipCountry = this.countryDataService.ipCountry;
    if(ipCountry){
      if(environment.pnpCountryList.indexOf(ipCountry) >= 0 || this.utils.isUserLoggedIn()){
        location.href = this.langCode
        return false
      }else if (window.location.href.includes('register')) {
        this.showRegNavBar = true;
        this.leftNavReg();
        this.zimplerToggleResize();
      }
    }else{
      this.checkIsRegistrationPage();
    }
     
   }
  checkValidUserPrivacyPolicy(message, userData) {
    if (userJurisdictions.includes(userData.jurisdiction) &&  ( message.includes("loginsuccess") || message.includes("pnpUserLogged") || !message)) {
        this.policiesVersionService.checkPolociesInfo()
    }
  }

  setModalState(modalOPtions) {
    this.emitterService.broadcastModalState(modalOPtions);
  }

  resetUrlWithoutParams(urlPath) {
    setTimeout(() => {
      history.replaceState(null, "", this.router.createUrlTree([this.langCode + urlPath]).toString())
    });
  }

  /**
   * when guest user launches the url with deposit step query params,
   *  sporadically user getting redirected to homepage instead of login page
   *  */
  redirectToLoginWhenNotLoggedin() {
    Promise.resolve(this.ajaxService.getLoginStatus()).then((data) => {
      if (data && data["status"] === false) {
        this.isUserLoggedIn = false;
        this.userDetail = null;
        this.userDetailsService.removeUserData();
        this.emitterService.broadcastStatusCall("updated");
        /*If user is not logged in and deposit modal needs to be open , first login*/
        if (this.openDepositModal) {
          this.router.navigate([this.langCode + "/login"]);
        }
      }
    });
  }

  toggleZDChat() {
    this.utilities.initChat();
  }

  

  toggleTugiChat() {
    if (this.isTugiChatBotOpen) {
      (window as any).tugiWidget?.closeWidget();
    } else {
      (window as any).tugiWidget?.openWidget();
    }
  }

  ngAfterViewInit() {
    this.balanceView = false;

    setTimeout((_) => {
      const ww = document.body.clientWidth;
      if (ww <= 992) {
        this.windowType = "mobile";
      } else {
        this.windowType = "desktop";
      }
    });

    this.getCountry();

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event && event.url.includes('gameplay')) {
          this.isGamePage = true;
        } else {
          this.isGamePage = false;
        }
        this.utils.setDynamicUrlHref();
        this.dynamicHrefPath = this.utils.getDynamicUrlHref();
      }
    });

  }

  preventDefaultAction(eventParam) {
    this.utils.preventDefaultEvent(eventParam);
  }
  navigateToForgotPassword() {

  }
  checkResizedOrientation() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
      this.closeSearch();
      this.balanceView = false;
      document.body.classList.remove("showHeader");
    }
  }

  getUserDetails(message) {
    if (
      !message ||
      (message.includes("Registration") && !message.includes("Failed")) ||
      !message.includes("userLoggedOff") ||
      !message.includes("Registration") ||
      message.includes("loginsuccess") ||
      message.includes("regOne") ||
      !message.includes("regTwo")
    ) {

      this.ajaxService.getProfileBalanceCurrency(true).pipe(takeUntil(this.destroy$)).subscribe(profileBalanceCurrency => {
        if (profileBalanceCurrency) {
          this.userDetailsService.setUserCurrencyInfo(profileBalanceCurrency["currency"]);
          this.userDetailsService.setUserCashBalance(
            profileBalanceCurrency["profile"]["balanceDetails"][
            "withdrawableBalance"
            ]
          );
          this.userDetailsService.setUserBalanceDetails(
            profileBalanceCurrency["profile"]["balanceDetails"]
          );
          this.userDetailsService.setUserBonusBalance(
            profileBalanceCurrency["profile"]["balanceDetails"]["totalBonus"]
          );
          this.userDetailsService.setUserTotalBalance(
            profileBalanceCurrency["profile"]["balanceDetails"][
            "withdrawableBalance"
            ] +
            profileBalanceCurrency["profile"]["balanceDetails"][
            "totalBonus"
            ]
          );
          this.emitterService.broadCastUserCountry(profileBalanceCurrency["profile"].country);
          this.userDetailsService.setUserCurrencyCode(
            profileBalanceCurrency["currencyDetails"].code
          );
          this.userDetailsService.setUserProfileDetails(
            profileBalanceCurrency["profile"]
          );
          this.checkValidUserPrivacyPolicy(message, profileBalanceCurrency["profile"])
          this.userDetailsService.setUserCurrencyDetails(
            profileBalanceCurrency["currencyDetails"]
          );
          this.userDetailsService.setUserCurrencySymbol(
            profileBalanceCurrency["currencyDetails"].symbol
          );
          this.userNickName = profileBalanceCurrency["profile"]["screenName"];
          this.userFullName = profileBalanceCurrency["profile"]["firstName"];
          this.email = profileBalanceCurrency["profile"]["emailId"];
          this.userCurrencySymbol = this.userDetailsService.getUserCurrencyDetails().symbol;
          this.userCashBalance = this.userDetailsService.getUserCashBalance();
          this.userTotalBalance = this.userDetailsService.getUserTotalBalance();
          this.userBonusBalance = this.userDetailsService.getUserBonusBalance();
          this.userDetail = this.userDetailsService.getUserProfileDetails();
          this.emitterService.userDataSourceComplete("User Data Updated");
          this.updateUserLangCode();
          sessionStorage.setItem("user", "true");
          //this.userDetailsService.setUserLangCode(profileBalanceCurrency["profile"].language, this.langCode);
          this.emitterService.broadcastLoadHomeBanner("userLoggedInn");
          this.emitterService.broadcastStatusCall("updated");
          this.emitterService.broadcurrencySymbolSourceSource(
            this.userCurrencySymbol
          );
          this.isUserLoggedIn = true;
          // setTimeout(() => {
          //   this.emitterService.broadcastLoginStatus(true);
          // }, 2000);
          this.emitterService.broadcastLoginStatus(true);
          const ww = document.body.clientWidth;
          if(window.location.href.includes('redirect=deposit-transactionStatus') && ww <= 992){
            this.pnpUserService.getPNPUserFromTransaction(profileBalanceCurrency["profile"]["country"]);
          }
          this.isPnPUser = false;
          if (
            profileBalanceCurrency["profile"]["payAndPlayUserDetails"] &&
            profileBalanceCurrency["profile"]["payAndPlayUserDetails"]
              .length > 0
          ) {
            this.isPnPUser = true;
          }

          if (
            this.userDetail &&
            this.userDetail.jurisdiction === "svenska" &&
            this.userDetail.userCategory === "c3"
          ) {
            this.isSwedenJurisdictionShowNotification = true;
          }

          if (
            message &&
            !message.includes("regOne") &&
            !message.includes("regTwo") && 
            !message.includes("pnpUserLogged") &&  
            !message.includes("COMPLETED") 
          ) {
            if (this.setLimitUrl) {
              this.router.navigate([this.langCode + "/setlimits"]);
            } else if (this.accountStatus) {
              this.router.navigate([this.langCode + "/accountstatus"]);
            } else if (this.accountPreference) {
              this.router.navigate([
                this.langCode + "/myaccount/preferencecenter",
              ]);
            } else {
              if(!this.utils.completeUserStatus){
                Promise.resolve(this.userDetailsService.checkUserProfile()).then((completeUserStatus) => {
                  this.triggerTransactionPage(completeUserStatus)
               });
              }else{
                this.triggerTransactionPage(this.utils.completeUserStatus)
              }
             
            }
          }

          this.callGTMEvent(profileBalanceCurrency["profile"]);
        }
      });
    }
  }
  triggerTransactionPage(completeUserStatus){
    if(completeUserStatus['status']=='SUCCESS'){
      this.utils.completeUserStatus = completeUserStatus;
    }else{
      this.utils.completeUserStatus = undefined;
    }
    
    this.completeUser = completeUserStatus;
    if (!this.completeUser.userProfileCompleted && !this.userDetailsService.isRealUserAccount() && !this.userDetailsService.checkIsPNPUser) {
      setTimeout(() => {
        this.utils.goToCompleteProfile();
      }, 2000);
    } else {
      //Promise.resolve(this.userDetailsService.getUserOTPCheck()).then(status => {
      if (
        !this.userDetailsService.isUserExemptedFromRegStepThree(
          this.userDetail["country"]
        ) &&
        !this.userDetailsService.getUserOTPCheck() &&
        !window.location.pathname.includes("trustly-process") &&
        !window.location.pathname.includes("/playnow") &&
        !this.isPnPUser
      ) {
        //this.codereVerify();
        setTimeout(() => {
          this.router.navigate([this.langCode + "/otp"]);
        }, 2000);
      } else {
        /*let amount,bonusCode = sessionStorage.getItem("amount");
            let bonusCode = sessionStorage.getItem("bonusCode");*/
        let queryString = {};
        if (
          sessionStorage.getItem("amount") ||
          sessionStorage.getItem("bonusCode")
        ) {
          if (sessionStorage.getItem("amount")) {
            queryString["amount"] = sessionStorage.getItem(
              "amount"
            );
          }
          if (sessionStorage.getItem("bonusCode")) {
            queryString["bonusCode"] = sessionStorage.getItem(
              "bonusCode"
            );
          }
          //this.router.navigate([this.langCode + '/deposit/'], { queryParams: queryString });

          /* In this if condition after succesfull login deposit modal opening in login page.
               To fix this i'm redirecting to homepage */
          this.router.navigate([this.langCode]);
          this.emitterService.broadcastModalState({
            name: "paymentModal",
            state: "open",
            cashierType: "deposit",
          });
        } else {
          if (this.appDetails.getGameLauncherParams()) {
            const ww = document.body.clientWidth;
            let gameDetails = this.appDetails.getGameLauncherParams();
            if (ww <= 1024) {
              // Check login modal or login page
              if (this.router.url.includes("quicklogin")) {
                this.router.navigate([], {
                  queryParams: { quicklogin: null },
                  queryParamsHandling: "merge",
                });
              } else {
                this.router.navigate([this.langCode]);
              }
              this.userDetailsService.gamePlayLaunchChecks(gameDetails.gameId, gameDetails.gameLaunchUrlPath);
            } else {
              this.router.navigate([this.langCode]);
              this.userDetailsService.gamePlayLaunchChecks(gameDetails.gameId, gameDetails.gameLaunchUrlPath);
            }
          } else {
            // Check login modal or login page
            if (this.router.url.includes("quicklogin")) {
              /*this.langCode is needed to apply the user profile language after login. Mainly used when post login and pre login languages are different*/
              this.router.navigate([this.langCode], {
                queryParams: { quicklogin: null },
                queryParamsHandling: "merge",
              });
            } else {
              this.router.navigate([this.langCode]);
            }
          }
        }
      }
    }
  }
   updateUserLangCode(){
    let langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode'): 'en';
    if(language[langCode] != this.userDetail.language){
      Promise.resolve(this.userDetailsService.checkUserProfile()).then(
        (completeUserStatus) => {
          let userDetail = {...this.userDetailsService.getUserProfileDetails()};
          this.utils.updateProfileLangCode(userDetail,completeUserStatus, true);
        })
     }
  }

  callGTMEvent(profile) {
    if (localStorage.getItem("gtmLoggedInEvent")) {
      let typeofLoggedUser = this.isPnPUser ? "pnp_user" : "user";
      let typeOfLogin = localStorage.getItem("gtmLoggedInEvent");
      this.utils.gtmEvent("userLoggedIn", {
        user: profile["email"],
        userExternalECR: profile["playerID"],
        typeOfUser: typeofLoggedUser,
        typelogin: typeOfLogin,
      });
      localStorage.removeItem("gtmLoggedInEvent");
    }
  }
  doLogout(logoutStatus) {
    this.balanceView = false;
    this.isSwedenJurisdictionShowNotification = false;
    this.isUserLoggedIn = false;
    this.userDetail = null;
    // Close Modals if they are open when Logout
    this.paymentInitialise = false;
    this.pnpDepositInitialise = false;
    this.showPendingWithdrawl = false;
    this.cashierType = "deposit";
    this.showPendingWithdrawl = false;
    this.cashierType = "deposit";
    if (logoutStatus.includes("userLoggedOff")) {
      this.userDetailsService.doLogout();
    }
  }

  headerNav() {
    this.emitterService.broadcastHeaderTopicSource("");
  }

  // codereVerify() {
  //   let logincredentials = {
  //     'email': this.email,
  //     'channel': "sms"
  //   }
  //   Promise.resolve(this.ajaxService.resendEmailVerification(logincredentials))
  //     .then(regData => {
  //     },
  //       SystemError => {
  //         this.emitterService.broadcastserverError('', "/register");
  //       });
  // }





  openRegNavbar() {
    let path = window.location.pathname.substring(3);
    let queryStr = window.location.search.slice(1);

    let params: any = {};
    let originalParams;

    if (queryStr !== "") {
    params = this.utils.parseQuery(queryStr);
    originalParams = { ...params };
    } else {
    originalParams = null;
    }
    
    params.signup = true;
    params.time = new Date().getTime();
    
    if (originalParams) {
    this.router.navigate(
    [this.langCode + path],
    {
          queryParams: params
    }).then(() => {

    history.replaceState(null, "", this.router.createUrlTree([this.langCode + path], { queryParams: originalParams }).toString())
    });
    } else if(!window.location.href.includes('register')){

    this.router.navigate(
    [this.langCode + path],
    {
          queryParams: params
    }).then(() => {

    history.replaceState(null, "", this.router.createUrlTree([this.langCode + path]).toString())
    });
    }
  }

  checkXSaleCondition(){
    if(this.countryDataService && this.countryDataService.country == "SE" && environment.xSaleBuumiCountries.indexOf(this.countryDataService.country) >=0){
      this.utils.openModal("swedishModal");
   }else{
    // Old Registration flow 
    // const ww = document.body.clientWidth;
    // if (ww <= 992) {
    //   this.router.navigate([this.langCode + "/register"])
    // }else{
      //   this.openRegNavbar();
    // }
    if(!this.userDetailsService.checkIsPNPUser()){
      this.router.navigate([this.langCode + "/register"]);
    }else{
      this.pnpService.openZimplerDeposit();
    }
     

   }
  }
  leftNavReg() {
    let eleSelectorReg: HTMLElement = document.querySelector(".main_register");

    setTimeout(() => {
      if (this.showRegNavBar) {
        $(".reg_toggle--container.show-Registration").css({ left: $(".header_logo--section").width() + "px", });
      } else {
        $(".reg_toggle--container.hide-Registration").css({ left: "-100% !important" });
      }
    });
  }

  searchGames(searchValue) {
    this.loadMoreSearchGames = this.searchResultsDefaultSize;
    this.selectedGames = null;
    if (searchValue === "") {
      this.selectedGamesOverlay = false;
      return;
    } else {
      this.selectedGamesOverlay = true;
    }
    if (this.sortedGameData && this.sortedGameData.length > 0) {
      this.totalSearchedGames = _.filter(this.sortedGameData, (game) => {
        return (
          game["name"].toLowerCase().indexOf(searchValue.toLowerCase()) !==
          -1 ||
          game["vendorDisplayName"]
            .toLowerCase()
            .indexOf(searchValue.toLowerCase()) !== -1
        );
      });
      this.selectedGames = this.totalSearchedGames.slice(
        0,
        this.searchResultsDefaultSize
      );
    } else {
      this.selectedGames = [];
    }
  }

  loadMoreSearchResult(event) {
    if (
      event.srcElement.classList &&
      event.srcElement.classList.contains("filteredgames")
    ) {
      if (
        $(".filteredgames").scrollTop() + $(".filteredgames").innerHeight() >=
        $(".filteredgames")[0].scrollHeight
      ) {
        this.loadMoreSearchGames += this.searchResultsDefaultSize;
        this.selectedGames = this.totalSearchedGames.slice(
          0,
          this.loadMoreSearchGames
        );
      }
    }
  }

  closeSearch(): void {
    this.selectedGamesOverlay = false;
    this.selectedGames = null;
    this.searchInput = undefined;
    $("#searchInputLabel").removeClass("active");
  }

  checkScrollUporDown() {
    this.scrollCurrentVal = window.pageYOffset;
    if (this.scrollCurrentVal === 0) {
      $("body").addClass("scrollPos").removeClass("scrollUp scrollDown");
    } else if (
      this.scrollCurrentVal > this.scrollPreviousVal &&
      this.scrollCurrentVal >= 60
    ) {
      $("body").addClass("scrollUp").removeClass("scrollDown scrollPos");
    } else if (this.scrollCurrentVal >= 60) {
      $("body").addClass("scrollDown").removeClass("scrollUp scrollPos");
    }
    this.scrollPreviousVal = this.scrollCurrentVal;
  }

  menuLinking(link) {
    if (window.location.href.indexOf(link) > -1) {
      alert("your url contains the name franky");
    }
  }

  openPageOrModal(page, modalId) {
    if (document.body.clientWidth <= 992) {
      this.router.navigate([this.langCode + "/" + page]);
    } else {
      setTimeout((_) => {
        this.utils.openModal(modalId);
      });
    }
  }

  openModal(modalId) {
    this.utils.openModal(modalId);
  }

  // Open Quick login modal with query param
  openQuickLogin() {
    this.router.navigate([], {
      queryParams: { quicklogin: true },
      queryParamsHandling: "merge",
    });
    this.openQuickLoginModal = true;
  }

  // Close Quick login modal without query param
  closeQuickLogin() {
    this.openQuickLoginModal = false;
    this.router.navigate([], {
      queryParams: { quicklogin: null },
      queryParamsHandling: "merge",
    });
  }

  hideZimplerUpdate() {
    if (this.isZimplerProfile) {
      this.emitterService.broadCastIsZimplerForm(false)
    }
  }

  goToTop() {
    try {
      window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
    setTimeout(() => {
      this.emitterService.broadCastUserCountry(
        this.countryDataService.IPCountry
      );
    }, 1000);
    this.hideZimplerUpdate()
  }

  closeModal(modalId: string) {
    this.utils.closeModal(modalId);
    if (modalId === "restrict_reg_modal") {
      this.loaderStatus.emit();
    }
  }

  getCountry() {
    Promise.resolve(this.countryDataService.getCountriesDetails()).then(
      (regData) => {
        if (regData && regData["country"]) {
          this.countryDataService.IPCountry = regData["country"];
          if (environment.zimplerPnp.indexOf(regData["country"]) >= 0  || environment.zimplerCountries.indexOf(regData["country"]) >= 0 || environment.semiPnpZimplerCountries.indexOf(regData["country"]) >= 0) {
            this.isCountryAllowed = 1;
            this.emitterService.broadCastIsCountryAllowed(this.isCountryAllowed)
            this.emitterService.broadCastUserCountry(regData["country"]);
            this.appDetails.country = regData["country"];
          } else {
            this.isCountryAllowed = 2;
            this.emitterService.broadCastIsCountryAllowed(this.isCountryAllowed)
            this.emitterService.broadCastUserCountry(null);
            this.appDetails.country = null;
          }
        }
      }
    );
  }


  register() {
    /* checking user login status, if user is already logged in, loading the homepage else navigate to registration page  */
    Promise.resolve(this.ajaxService.getLoginStatus()).then((data) => {
      if (data["status"]) {
        this.appDetails.loadHomepage(this.langCode);
      } else {
        this.router.navigate([this.langCode + "/register/step1/"], {
          queryParams: { prevUrl: window.location.pathname },
        });
      }
    });
  }



  initialisePayment() {
    if (this.userDetailsService.checkIsPNPUser() && this.userDetailsService.checkZimplerDepositOpen()) {
      this.pnpService.openZimplerDeposit();
    } else {
      this.emitterService.broadcastModalState({
        name: "paymentModal",
        state: "open",
        cashierType: "deposit",
      });
    }
  }

  redirectiondecider(url: string) {
    this.routerEvent = this.router.events
      .pipe(filter((event) => event instanceof NavigationError))
      .subscribe((e) => {
        if (e["error"]["message"].includes(url) && e["id"] === 2) {
          this.emitterService.broadcastAllGamesEmitter(url);
        } else {
        }
      });
  }

  // On scroll above 500px on header we required different css
  changeHeaderTheme() {
    this.scrollCurrentVal = window.pageYOffset;
    if (this.scrollCurrentVal <= 10) {
      $(".main_header").removeClass("headerOnScroll");
    } else {
      $(".main_header").addClass("headerOnScroll");
    }
  }

  
  openNavPanel() {
    /*- close step two -*/
    //remove query params and close step two in the background, if it is opened 
    if(this.utils.isRegisterPage()){
      this.router.navigate([this.langCode]);
          setTimeout(()=>{
            this.openMenuPanel();
          },10)
    }else{
      this.openMenuPanel();
    } 
  }
  openMenuPanel(){
    if(location.href.includes('page=step2')){
      this.utils.removeParam({'page': null})
    }
    if(!this.utils.getIsSideMenuOpened()){
      this.emitterService.broadcastRouteChange(false);
    }
    /*- close step two -*/
    this.utils.setIsSideMenuOpened(!this.utils.getIsSideMenuOpened());
    this.emitterService.broadCastToggleNavPanel(this.utils.getIsSideMenuOpened());
    $(".dropdown-section--wrap").parent().find("ul").removeClass("expanded");
    $(".dropdown-section--btn").find("i").removeClass("rotate");
  }

  getAllPromotionData(forceData) {
    Promise.resolve(this.promotionsService.getPromotionsData(forceData)).then(promotionsResp => {
      this.specialPromotions = promotionsResp;
      this.specialPromotions = (this.specialPromotions.filter(promotionIndexVal => ((promotionIndexVal["name"].toLowerCase()).indexOf("-featured") != -1))).slice(0, 2);
    });
  }
  checkUserLoginStatus(){
    let isUserEstoniaJuridiction = this.userDetailsService?.userProfileDetails?.jurisdiction == userJurisdictions[0] ? true : false;
   return this.utils.isUserLoggedIn() && isUserEstoniaJuridiction
  }
  ngOnDestroy() {
     document.removeEventListener('tugi-widget-opened', this.onTugiWidgetOpened);
     document.removeEventListener('tugi-widget-closed', this.onTugiWidgetClosed);
    //Unsubscribing componentSetting subscriber, on component destroy
    this.balanceView = false;
    this.selectedGames = false;

    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
